module.exports = __webpack_public_path__ + "static/git-f22af86c3cf9109391e165108624ac2a.png";